import { CustomNodeType, actionBarHeight } from './config';

export interface ActionBtns {
  switchAction: boolean | Record<string, any>;
  linkAction: boolean | Record<string, any>;
  addAction: boolean | Record<string, any>;
  settingAction: boolean | Record<string, any>;
  deleteAction: boolean | Record<string, any>;
}

function handler(node) {
  // @ts-ignore
  if (!window.commonNodeEvtHandler) {
    // @ts-ignore
    window.commonNodeEvtHandler = function (e) {
      const target = e.target as HTMLElement;
      // 链接
      if (target.classList.contains('activity-actionbar-link-btn')) {
        const id = target.getAttribute('data-id');

        // @ts-ignore
        window.onActivityLinkProducts(id);
      }
      // 设置
      else if (target.classList.contains('activity-actionbar-setting-btn')) {
        const id = target.getAttribute('data-id');

        // @ts-ignore
        window.onActivitySettings(id);
      }
    };
  }

  // @ts-ignore
  return window.commonNodeEvtHandler;
}

export const generateActionBar = function (node: any) {
  node.actionBar =
    node.actionBar ||
    ({
      switchAction: { open: true },
      linkAction: true,
      addAction: true,
      settingAction: true,
      deleteAction: true
    } as ActionBtns);

  let hasSettings = false;
  if (node.jsonData.level === 2) {
    if (node.type === CustomNodeType.POLICY && node.jsonData?.policyInfo.name) {
      hasSettings = true;
    }
  } else if (node.jsonData.level === 3 && node.jsonData?.equityInformationRule?.name) {
    hasSettings = true;
  }
  const conditionHasSetting =
    [CustomNodeType.CONDITIONS, CustomNodeType.SIMPLE_CONDITION].includes(node.type) &&
    (node.isPre ? node.jsonData?.conditionDesc : node.jsonData?.effectConditionDesc);
  if (conditionHasSetting) {
    hasSettings = true;
  }

  const linkBtn = `<span data-id="${
    node.id
  }" class="activity-actionbar-link-btn iconfont icon-lianjie" style="margin-left:5px;font-size:18px;color:${
    node.jsonData.promotionItemStr || node.jsonData?.equityInformationRule?.equityInfoItemStr ? '#d70a25' : '#333'
  };cursor:pointer;"></span>`;
  const settingBtn = `<span data-id="${
    node.id
  }" class="activity-actionbar-setting-btn iconfont icon-shezhi" style="margin-left:5px;font-size:18px;color:${
    hasSettings ? '#d70a25' : '#333'
  };cursor:pointer;"></span>`;

  // 只监听一次事件
  document.body.removeEventListener('click', handler(node));
  document.body.addEventListener('click', handler(node));

  return `
    <div style="display: flex;align-items: center;height: ${actionBarHeight}px;">
      <div style="margin-left:auto;display: flex;align-items: center;">
        ${node.actionBar.linkAction ? linkBtn : ''}
        ${node.actionBar.settingAction ? settingBtn : ''}
      </div>
    </div>
  `;
};
